// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__jNqDc","label":"Checkbox_label__RXuGv","input":"Checkbox_input__7efbE"};